export function tt_icon(icon: string, text: string, small = false, classes: string[] = []): string {
    return `<i class="fa fa-${icon} ${classes.join(' ')} ${(small ? 'tt-small' : 'tt')}">`
        + tt_tooltip(text) + '</i>';
}

export function tt_tooltip(text: string): string {
    return '<span class="tt-anchor"><span class="tt-inner">' + text + '</span></span>';
}
